import { render, staticRenderFns } from "./TravelPeriodList.vue?vue&type=template&id=6a0142d6&"
import script from "./TravelPeriodList.vue?vue&type=script&lang=js&"
export * from "./TravelPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports